import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './CampaignRegistar.css';
import { createCampaign, fetchCampaigns } from '../api/campaign';
import { getCompanyPlans } from '../api/plan';
import { usePlans } from '../utils/usePlans.js';
import { useParams } from 'react-router-dom';

const CampaignRegistration = () => {
  const [campaignCode, setCampaignCode] = useState('');
  const [planName, setPlanName] = useState('');
  const [priceId, setPriceId] = useState('');
  const [error, setError] = useState(null);
  const [planType, setPlanType] = useState('premium');
  const navigate = useNavigate();
  const { loading } = usePlans();
  const [upgradePlanId, setUpgradePlanId] = useState('');
  const [upgradeType, setUpgradeType] = useState('0');
  const [companyPlans, setCompanyPlans] = useState([]);
  const { companyId } = useParams();
  const [upgradePlan, setUpgradePlan] = useState([]);
  const [usageDays, setUsageDays] = useState('');
  const selectedPlan = companyPlans.find((p) => p.price_id === priceId);
  const [exclusivePlan, setExclusivePlan] = useState('');

  useEffect(() => {
    if (companyId) {
      fetchCompanyPlans(companyId);
    }
  }, [companyId]);

  const fetchCompanyPlans = async (companyId) => {
    try {
      const plans = await getCompanyPlans(companyId);
      setCompanyPlans(plans.plans);
    } catch (error) {
      console.error('アップグレードプラン取得エラー:', error);
    }
  };

  useEffect(() => {
    if (!priceId) {
      setUpgradePlan([]);
      return;
    }

    const upgradePlanOptions = companyPlans.filter(
      (p) => p.price_id !== priceId
    );
    setUpgradePlan(upgradePlanOptions);
  }, [priceId, companyPlans]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    try {
      await createCampaign(
        companyId,
        campaignCode,
        planName,
        priceId,
        planType,
        upgradePlanId,
        upgradeType,
        selectedPlan?.interval === 'one_time' ? usageDays : null,
        exclusivePlan
      );

      navigate('/campaignlist');
    } catch (err) {
      console.error(err);
      if (err.response?.data?.message) {
        setError(err.response.data.message);
      } else {
        console.error('バリデーションエラー内容:', err.response.data);
        setError('登録に失敗しました。');
      }
    }
  };

  if (loading) return <p>プランを読み込み中...</p>;

  return (
    <div className="campaignRegisterBody">
      <h2 className="campanyRegisterTitle">キャンペーン登録画面</h2>

      <div className="campaignContainer">
        {error && <p className="error">{error}</p>}

        <div className="campaignRegisterElement">
          <label>
            キャンペーンコード
            <input
              type="text"
              placeholder="例: 1234"
              className="campaignElement"
              value={campaignCode}
              onChange={(e) => setCampaignCode(e.target.value)}
              required
            />
          </label>

          <label>
            キャンペーン名
            <input
              type="text"
              placeholder="例: FreeCampaign"
              className="campaignElement"
              value={planName}
              onChange={(e) => setPlanName(e.target.value)}
              required
            />
          </label>

          <label>
            キャンペーンプラン
            <select
              className="campaignElement"
              value={priceId}
              onChange={(e) => setPriceId(e.target.value)}
              required
            >
              <option value="">プランを選択してください</option>
              {companyPlans.map((plan) => (
                <option key={plan.price_id} value={plan.price_id}>
                  {plan.name}
                </option>
              ))}
            </select>
          </label>

          {selectedPlan?.interval === 'one_time' && (
            <label>
              使用期間（日数）
              <input
                type="number"
                min="1"
                className="campaignElement"
                placeholder="例: 30"
                value={usageDays}
                onChange={(e) => setUsageDays(Number(e.target.value))}
                required
              />
            </label>
          )}

          <div>
            <label>アップグレードタイプ</label>
            <select
              className="campaignElement"
              value={upgradeType}
              onChange={(e) => setUpgradeType(e.target.value)}
              required
            >
              <option value="0">なし</option>
              <option value="1">1</option>
              <option value="2">2</option>
            </select>
          </div>

          {upgradeType !== '0' && (
            <label>
              アップグレード先プランコード
              <select
                className="campaignElement"
                value={upgradePlanId}
                onChange={(e) => setUpgradePlanId(e.target.value)}
              >
                <option value="">選択してください</option>
                {upgradePlan.map((plan) => (
                  <option key={plan.id} value={plan.price_id}>
                    {plan.name}
                  </option>
                ))}
              </select>
            </label>
          )}
          <label>
            同時契約不可プラン
            <select
              className="campaignElement"
              value={exclusivePlan || ''}
              onChange={(e) => setExclusivePlan(e.target.value)}
            >
              <option value="">選択してください</option>
              {upgradePlan?.map((plan) => (
                <option key={plan.price_id} value={plan.price_id}>
                  {plan.name}
                </option>
              ))}
            </select>
          </label>

          <div className="planSelect">
            <label>料金プラン</label>
            <select
              value={planType}
              onChange={(e) => setPlanType(e.target.value)}
              className="selectOption"
            >
              <option value="premium">プレミアム</option>
              <option value="selection">セレクション</option>
            </select>
          </div>
        </div>

        <button type="submit" className="submitButton" onClick={handleSubmit}>
          登録する
        </button>

        <button
          className="campaignRegisterBackButton"
          onClick={() => navigate('/campaignlist')}
        >
          キャンペーン一覧に戻る
        </button>

        <button
          className="campaignRegisterBackButton2"
          onClick={() => navigate('/implpage')}
        >
          企業ポータルに戻る
        </button>
      </div>
    </div>
  );
};

export default CampaignRegistration;
